"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledTextInput = exports.StyledSingleLineTextInput = exports.StyledMultilineTextInput = exports.TextInput = void 0;
var react_1 = __importStar(require("react"));
var InputError_1 = require("../InputError");
var styles_1 = require("./styles");
Object.defineProperty(exports, "StyledSingleLineTextInput", { enumerable: true, get: function () { return styles_1.StyledSingleLineTextInput; } });
Object.defineProperty(exports, "StyledTextInput", { enumerable: true, get: function () { return styles_1.StyledSingleLineTextInput; } });
Object.defineProperty(exports, "StyledMultilineTextInput", { enumerable: true, get: function () { return styles_1.StyledMultilineTextInput; } });
var LabelAndHelpText_1 = require("../Shared/LabelAndHelpText");
var SingleLineTextInput = (0, react_1.forwardRef)(function (_a, ref) {
    var size = _a.size, required = _a.required, hasError = _a.hasError, errorText = _a.errorText, errorMessageId = _a.errorMessageId, props = __rest(_a, ["size", "required", "hasError", "errorText", "errorMessageId"]);
    var InputComponent = (react_1.default.createElement(styles_1.StyledSingleLineTextInput, __assign({}, props, { "$size": size, ref: ref })));
    return (react_1.default.createElement(InputError_1.InputError, { errorText: hasError ? errorText : undefined, errorMessageId: errorMessageId, size: size }, InputComponent));
});
var MultiLineTextInput = (0, react_1.forwardRef)(function (_a, ref) {
    var size = _a.size, hasError = _a.hasError, errorText = _a.errorText, errorMessageId = _a.errorMessageId, border = _a.border, props = __rest(_a, ["size", "hasError", "errorText", "errorMessageId", "border"]);
    var onChange = props.onChange;
    var autoResize = function (element) {
        element.style.height = 'auto';
        element.style.height = "".concat(element.scrollHeight + (border ? 2 : 0), "px");
    };
    var handleInputChange = function (event) {
        autoResize(event.target);
        if (onChange) {
            onChange(event);
        }
    };
    var TextAreaComponent = (react_1.default.createElement(styles_1.StyledMultilineTextInput, __assign({}, props, { "$size": size, rows: 1, onChange: handleInputChange, ref: ref })));
    return (react_1.default.createElement(InputError_1.InputError, { errorText: hasError ? errorText : undefined, errorMessageId: errorMessageId, size: size }, TextAreaComponent));
});
/**
 * A basic text input.
 */
exports.TextInput = (0, react_1.forwardRef)(function (_a, ref) {
    var name = _a.name, _b = _a.size, size = _b === void 0 ? 'small' : _b, _c = _a.border, border = _c === void 0 ? true : _c, hasError = _a.hasError, required = _a.required, props = __rest(_a, ["name", "size", "border", "hasError", "required"]);
    var errorMessageId = "".concat(name, "-error-id");
    var commonProps = {
        name: name,
        border: border,
        hasError: hasError,
        hasBorder: border,
        'aria-invalid': hasError,
        'aria-required': required,
        'aria-describedby': hasError ? errorMessageId : undefined,
        errorMessageId: errorMessageId,
    };
    if (props.multiline) {
        return (react_1.default.createElement(MultiLineTextInput, __assign({ size: size }, commonProps, props, { ref: ref })));
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        props.additionalText && (react_1.default.createElement(LabelAndHelpText_1.LabelAndHelpText, { id: props.id, label: props.additionalText.label, helpText: props.additionalText.helpText, size: size })),
        react_1.default.createElement(SingleLineTextInput, __assign({ size: size }, commonProps, props, { ref: ref }))));
});
